module.exports = __webpack_public_path__ + "static/awards-logo8-f629e374bff753432495352bc01004a0.jpg";